import { DistributionChannelConnector, IntegrationPartner } from '@/models/distributionChannels';
import { FC } from 'react';
import { CyclrDestinationConnectionToggle } from './CyclrDestinationConnectionToggle';

type DestinationConnectionToggleProps = {
  connector: DistributionChannelConnector;
  deauthenticateDisabled?: boolean;
  onChangeConnectionInProgress?: (connector: DistributionChannelConnector | null) => void;
};

export const DestinationConnectionToggle: FC<DestinationConnectionToggleProps> = ({
  connector,
  deauthenticateDisabled = false,
  onChangeConnectionInProgress,
}) => {
  switch (connector.integrationPartner) {
    case IntegrationPartner.CYCLR:
      return (
        <CyclrDestinationConnectionToggle
          deauthenticateDisabled={deauthenticateDisabled}
          connector={connector}
          onChangeConnectionInProgress={onChangeConnectionInProgress}
        />
      );
    default:
      return null;
  }
};
